import { render, staticRenderFns } from "./CdnImg.vue?vue&type=template&id=c31455f4&"
import script from "./CdnImg.vue?vue&type=script&lang=js&"
export * from "./CdnImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports